import React from 'react';
import { FileText, Droplet, Award, Coffee, Sparkles } from 'lucide-react';

const items = [
  {
    icon: FileText,
    title: 'Pisno gradivo',
    desc: 's celotno masažno rutino in navodili za masažo odraščajočega otroka.',
  },
  {
    icon: Droplet,
    title: 'Kakovostno masažno olje in komplet',
    desc: 'za pomirjanje trebušnih krčev.',
  },
  {
    icon: Award,
    title: 'Priznanje o udeležbi in majhno presenečenje',
    desc: '',
  },
  {
    icon: Coffee,
    title: 'Prijetno vzdušje',
    desc: 'ob pijači in prigrizkih v družbi mamic.',
  },
  {
    icon: Sparkles,
    title: 'Podpora za mamico z aurikuloterapijo',
    desc: '',
  },
];


/* =========================================
   POSAMEZNA ROČNO NARISANA KARTICA
   ========================================= */
const SketchCard = ({ icon: Icon, title, desc, className = '' }) => (
  <div
    className={`relative px-5 py-5 lg:px-6 lg:py-5 min-h-[138px] ${className}`}
  >

    {/* Prostoročno narisan svinčnik okvir */}
    <svg
      aria-hidden="true"
      viewBox="0 0 1000 400"
      preserveAspectRatio="none"
      className="absolute inset-0 w-full h-full pointer-events-none"
    >

      {/* Glavna črta */}
      <path
        d="
          M40 32
          C148 18, 292 29, 431 24
          C586 19, 735 31, 943 26
          C970 27, 981 47, 976 79
          C969 151, 980 232, 970 315
          C966 361, 954 385, 921 390
          C758 397, 614 387, 468 392
          C314 398, 174 386, 58 392
          C29 393, 19 370, 24 338
          C30 265, 17 190, 24 116
          C27 71, 25 43, 40 32
          Z
        "
        fill="none"
        stroke="rgba(111,91,65,0.43)"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Druga nežna črta za učinek svinčnika */}
      <path
        d="
          M46 37
          C161 28, 304 34, 439 30
          C597 25, 746 36, 937 32
          C963 32, 973 51, 969 82
          C965 157, 976 237, 965 311
          C961 354, 949 378, 915 384
          C764 391, 612 382, 464 387
          C311 393, 180 381, 64 387
          C37 388, 28 366, 31 335
          C36 259, 24 188, 31 121
          C34 78, 32 49, 46 37
          Z
        "
        fill="none"
        stroke="rgba(111,91,65,0.15)"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

    </svg>


    {/* Vsebina kartice */}
    <div className="relative z-10 h-full flex flex-col justify-center">

      {/* Vijola ikonica brez barvnega ozadja */}
<div className="w-10 h-10 lg:w-11 lg:h-11 flex items-center justify-center mb-3">
  <Icon
    size={19}
    className="text-violet-800"
  />
</div>

      <p className="text-stone-700 text-[14px] lg:text-[15px] leading-relaxed">
        {title} {desc}
      </p>

    </div>

  </div>
);


const CourseInclusionsSection = () => (
  <section
  className="
    relative
    overflow-hidden
    py-8
    lg:py-10
  "
    data-testid="inclusions-section"
  >

    <div className="relative w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">

      {/* =========================================
          NASLOV
          ========================================= */}
      
<div className="text-center mb-6 lg:mb-7">
        <h2
          className="font-serif text-2xl sm:text-3xl text-stone-800 font-bold mb-3"
          data-testid="inclusions-title"
        >
          Kaj prejmeš na tečaju?
        </h2>

        <p className="text-stone-600 leading-relaxed max-w-xl mx-auto">
          Da bo masaža postala vajin vsakdan tudi doma, ob vpisu prejmeš:
        </p>

      </div>


      {/* =========================================
          VSEH 5 KARTIC NA ENEM EKRANU
          
          Desktop:
          1   2   3
            4   5
          ========================================= */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-4 lg:gap-5">

        {items.map((it, i) => {

          const Icon = it.icon;

          let position = 'lg:col-span-2';

          if (i === 3) {
            position = 'lg:col-span-2 lg:col-start-2';
          }

          if (i === 4) {
            position = 'sm:col-span-2 lg:col-span-2 lg:col-start-auto';
          }

          return (
            <SketchCard
              key={i}
              icon={Icon}
              title={it.title}
              desc={it.desc}
              className={position}
            />
          );

        })}

      </div>

    </div>

  </section>
);

export default CourseInclusionsSection;